import { Card, Stack } from '@mui/material';

import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { ViewType } from 'common/constants';
import { FeatureFlagsKeysEnum } from 'common/constants/FeatureFlags';
import { REGULATION_TAB_VALUES } from 'common/constants/RegulationInventoryConstants';
import { ReportingLibraryTabs } from 'common/constants/ReportingLibraryConstants';
import {
	ACTION_PLAN_TAB_CONSTANTS,
	TAXONOMY_ENTITY_INDEX,
} from 'common/constants/TaxonomyConstants';
import {
	clearUploadedDocumentProgress,
	setHomePageTabIndex,
	setHorizonScanningSearchText,
	setIsPRCDetailsPage,
	setIsRelationshipMappingDeleted,
	setMappingDrawer,
	setMultiSelectInstitutionFilterData,
	setMultiSelectJurisdictionFilterData,
	setMultiSelectProductFilterData,
	setRegChangeSelectedTabIndex,
	setRiskRefSelectedTab,
	setSelectedReportingTab,
} from 'common/store/reducer/commonReducer';
import { setTMSelectedTab } from 'common/store/reducer/controlTestScriptReducer';
import { setClearAllDates } from 'common/store/reducer/horizonScanReducer';
import { setSelectedTabValue } from 'common/store/reducer/mappingDetailsReducer';
import {
	setRegulationToggleButton,
	setRegInvLandingSelectedTab,
} from 'common/store/reducer/regulationInventoryReducer';
import { setCurrentTab } from 'common/store/reducer/settingsReducer';
import {
	setModelTabIndex,
	setSimulationTabIndex,
	setSimulationControlOwnerValue,
	setSimulationControlTypeValue,
	setSimulationControlFrequencyValue,
	setSimulationViewTypeValue,
} from 'common/store/reducer/simulationReducer';
import {
	setRiskRefTaxonomyFilter,
	setRiskRefSearchText,
	setTaxonomyViewTypeValue,
	setTaxonomySelectedAppliedFilterList,
	setEntityResponseData,
	setEntityCountData,
	setOriginalEntityResponseData,
	setAllEntityResponseData,
	setAllOriginalEntityResponseData,
	setIsPRCEditDataDeleting,
	setIsRegenerateMappingBtnClicked,
} from 'common/store/reducer/taxonomyReducer';
import {
	setUserManagementSelectedTab,
	setOverviewSelectedTab,
	setPermissionsTabIndex,
} from 'common/store/reducer/userManagementReducer';
import { scrollToTop, urlWithTenant } from 'common/utils/utilFunctions';

import { useFeatureFlag } from 'hooks/useFeatureFlags';

import { QuickLinksCardsValue } from 'features/HomePage/api/type-def';

import quickLinksCardsStyle from './QuickLinksCards.module.scss';

const { RECENTLY_VIEWED_TAB } = ReportingLibraryTabs;
const { PROCESS } = TAXONOMY_ENTITY_INDEX;
const { REACT_APP_ENVIRONMENT } = process.env;
const { TAB_MAPPING } = ACTION_PLAN_TAB_CONSTANTS;
const { IS_PRC_CARD_VIEW_ENABLED } = FeatureFlagsKeysEnum;
const { TABLE, GRID, CARD } = ViewType;
export const QuickLinksCards = (props: QuickLinksCardsValue) => {
	const dispatch = useDispatch();
	const { label, id, path, imgLink } = props;
	const isPrcCardViewEnabled = useFeatureFlag(IS_PRC_CARD_VIEW_ENABLED);
	const navigate = useNavigate();
	const navigateToPath = () => {
		if (path !== '') {
			navigate(urlWithTenant(path));
			dispatch(setHomePageTabIndex(0));
		}
	};
	useEffect(() => {
		dispatch(
			setRiskRefSelectedTab({
				tableIndex: `${PROCESS}-${REACT_APP_ENVIRONMENT}`,
				indexType: 0,
			}),
		);
		dispatch(setRiskRefTaxonomyFilter([]));
		dispatch(setRiskRefSearchText(''));
		dispatch(setHorizonScanningSearchText(''));
		dispatch(setRegChangeSelectedTabIndex(0));
		dispatch(setRegulationToggleButton('regulations'));
		dispatch(setTMSelectedTab(0));
		dispatch(setUserManagementSelectedTab(0));
		dispatch(setOverviewSelectedTab(0));
		dispatch(setPermissionsTabIndex(0));
		dispatch(setCurrentTab('1'));
		dispatch(setMultiSelectProductFilterData([]));
		dispatch(setMultiSelectJurisdictionFilterData([]));
		dispatch(setMultiSelectInstitutionFilterData([]));
		dispatch(setModelTabIndex(0));
		dispatch(setSimulationTabIndex(0));
		dispatch(setSimulationControlOwnerValue(''));
		dispatch(setSimulationControlTypeValue(''));
		dispatch(setSimulationControlFrequencyValue(''));
		dispatch(
			setRegInvLandingSelectedTab(REGULATION_TAB_VALUES.CURRENT_INVENTORY),
		);
		dispatch(setSimulationViewTypeValue(GRID));
		dispatch(setSelectedTabValue(TAB_MAPPING));
		dispatch(setMappingDrawer(false));
		dispatch(setTaxonomyViewTypeValue(isPrcCardViewEnabled ? CARD : TABLE));
		dispatch(setTaxonomyViewTypeValue(ViewType.CARD));
		dispatch(setTaxonomySelectedAppliedFilterList([]));
		dispatch(setClearAllDates());
		dispatch(setIsRelationshipMappingDeleted(false));
		dispatch(
			setSelectedReportingTab({
				reportingLibraryTabIndex: 0,
				reportingLibraryTabName: RECENTLY_VIEWED_TAB,
			}),
		);
		dispatch(clearUploadedDocumentProgress());
		dispatch(setEntityResponseData([]));
		dispatch(setEntityCountData([]));
		dispatch(setOriginalEntityResponseData([]));
		dispatch(setAllEntityResponseData([]));
		dispatch(setAllOriginalEntityResponseData([]));
		dispatch(setIsPRCDetailsPage(false));
		dispatch(setIsPRCEditDataDeleting(false));
		dispatch(setIsRegenerateMappingBtnClicked(false));
		setTimeout(() => {
			scrollToTop();
		}, 0);
	}, []);
	return (
		<Card
			data-testid="quicklink-actions-card"
			className={quickLinksCardsStyle['quick-links-card']}
			key={id}
			onClick={navigateToPath}
		>
			<Stack direction="column" spacing={2}>
				<div className={quickLinksCardsStyle['quick-links-img']}>{imgLink}</div>
				<div className={quickLinksCardsStyle['quick-links-label']}>{label}</div>
			</Stack>
		</Card>
	);
};
